/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrgUnitRetrievePathId, OrgOrgUnitRetrieveStatus200 } from "../types/OrgOrgUnitRetrieve.ts";

function getOrgOrgUnitRetrieveUrl(id: OrgOrgUnitRetrievePathId) {
	const res = { method: "GET", url: `/api/org/org-unit/${id}/` as const };

	return res;
}

/**
 * {@link /api/org/org-unit/:id/}
 */
export async function orgOrgUnitRetrieve(id: OrgOrgUnitRetrievePathId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgOrgUnitRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgOrgUnitRetrieveUrl(id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
